import React, { Fragment } from "react"
import styled, { keyframes } from "styled-components"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import tada from "react-animations/lib/tada"
import Button from "./themed-html-components/Button"

const animation = keyframes`${tada}`

const Icon = styled.i`
  animation: 1s ${animation};
  color: #ee3b3b;
  font-size: 4em;
`

const IconContainer = styled.div`
  text-align: center;
  margin: 20px 0;
`

const MessageContainer = styled.div`
  text-align: center;
`

const Header = styled.h3`
  color: ${prop => prop.theme.primaryColor};
`

// eslint-disable-next-line react/prop-types
function BrokenDashboardMessage({ t, onReload, theme }) {
  return (
    <Fragment>
      <IconContainer className="col-sm-12">
        <Icon className="fa fa-exclamation-triangle" aria-hidden="true" />
      </IconContainer>
      <MessageContainer className="col-sm-12">
        <Header theme={theme}>{t("Common.SeriousErrorHeader")}</Header>
        <p>{t("Dashboards.ErrorMessages.ApiError")}</p>
        <div className="text-center">
          <Button text={t("Common.TryAgain")} onClick={onReload} />
        </div>
      </MessageContainer>
    </Fragment>
  )
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(BrokenDashboardMessage)



// WEBPACK FOOTER //
// ./src/components/BrokenDashboardMessage.jsx